/**
 * Central Test Case Generator theme.
 * Every page using theme.palette.* inherits this automatically.
 */
import {
  createUnifiedTheme,
  defaultTypography,
  palettes,
  genPageTheme,
  shapes,
} from '@backstage/theme';
import type { BackstageTypography } from '@backstage/theme';

export const FONT_STACK =
  'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif';

const ACCENT = {
  primary: '#4c8dff',
  primaryDark: '#2f6ae0',
  secondary: '#1fc7b6',
};

const typography: BackstageTypography = {
  ...defaultTypography,
  fontFamily: FONT_STACK,
  htmlFontSize: 16,
  h1: { ...defaultTypography.h1, fontWeight: 700 },
  h2: { ...defaultTypography.h2, fontWeight: 700 },
  h3: { ...defaultTypography.h3, fontWeight: 600 },
};

const pageTheme = {
  home: genPageTheme({ colors: ['#4c8dff', '#1fc7b6'], shape: shapes.wave }),
  documentation: genPageTheme({
    colors: ['#4c8dff', '#1fc7b6'],
    shape: shapes.wave2,
  }),
  tool: genPageTheme({ colors: ['#2f6ae0', '#4c8dff'], shape: shapes.round }),
  service: genPageTheme({ colors: ['#4c8dff', '#1fc7b6'], shape: shapes.wave }),
  default: genPageTheme({ colors: ['#4c8dff', '#1fc7b6'], shape: shapes.wave }),
};

export const lightThemeSystemFont = createUnifiedTheme({
  palette: {
    ...palettes.light,
    primary: { main: ACCENT.primary, dark: ACCENT.primaryDark },
    secondary: { main: ACCENT.secondary },
  },
  typography,
  pageTheme,
  // Suppress backstage header (we have our own topbar).
  // This is a global override, so all pages will hide the default header.
  components: {
    BackstageHeader: {
      styleOverrides: {
        header: { display: 'none' },
      },
    },
  },
});

export const darkThemeSystemFont = createUnifiedTheme({
  palette: {
    ...palettes.dark,
    primary: { main: ACCENT.primary, dark: ACCENT.primaryDark },
    secondary: { main: ACCENT.secondary },
  },
  typography,
  pageTheme,
  // Suppress backstage header (we have our own topbar).
  // This is a global override, so all pages will hide the default header.
  components: {
    BackstageHeader: {
      styleOverrides: {
        header: { display: 'none' },
      },
    },
  },
});
